<h3 mat-dialog-title style="width: 100%; text-align: center;">SSP Import</h3>
<div mat-dialog-content>
  <div>
    <div>
      <mat-form-field style="width: 100%">
        <mat-label>Select Compliance Areas</mat-label>
        <mat-select  [(value)]="complianceAreaIds" style="width: 100%;" multiple
                    (selectionChange)="updateProjects()">
          <mat-option *ngFor="let area of complianceAreas"
                      [value]="area.complianceAreaId">{{area.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field style="width: 100%">
        <mat-label>Select Project</mat-label>
        <mat-select  [(value)]="projectId" style="width: 100%;">
          <mat-option [value]="0">Create New</mat-option>
          <mat-option *ngFor="let project of projects" style="display: block; cursor: pointer;"
                      [value]="project.projectId">{{project.name || 'Unnamed'}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field style="width: 100%">
        <mat-label>Project Name</mat-label>
        <input [(ngModel)]="projectName"  style="width: 100%;" matInput />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field style="width: 100%">
        <mat-label>Select IT Profile</mat-label>
        <mat-select  [(value)]="itProfileId" style="width: 100%;">
          <mat-option [value]="0">Create New</mat-option>
          <mat-option *ngFor="let profile of itProfiles" style="display: block; cursor: pointer;"
                      [value]="profile.clientITProfileId">{{profile.name || 'Unnamed'}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="!itProfileId">
      <mat-form-field style="width: 100%">
        <mat-label>IT Profile Name</mat-label>
        <input [(ngModel)]="profileName"  style="width: 100%;" matInput />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field style="width: 100%">
        <mat-label>Additional User</mat-label>
        <mat-select  [(value)]="additionalUserId" style="width: 100%;">
          <mat-option *ngFor="let user of additionalUsers" style="display: block; cursor: pointer;"
                      [value]="user.userId">{{user.firstName}} {{user.lastName}}{{(!user.firstName && !user.lastName) ? user.emailAddress : ''}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <p>{{file?.name}}</p>
      <button mat-raised-button
              (click)="inputFile.click()"
              matTooltip="Accepted file: .docx">
        Select Document
      </button>
      <input #inputFile
             type="file"
             accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
             (change)="selectFile($event)"
             [style.display]="'none'">
    </div>

  </div>
</div>
<div mat-dialog-actions style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
  <button mat-raised-button [disabled]="complianceAreaIds.length == 0 || (!projectName && !projectId)|| (additionalUserId == 0) || (!itProfileId && !profileName)|| !file" (click)="import()">Ok</button>
  <button mat-raised-button (click)="onClose()">Cancel</button>
</div>
